import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="app-footer">
      <div className="footer-left">
        <Link to="/terms" className="footer-link" aria-label="Terms and Conditions">
          Terms
        </Link>
        {/* <Link to="/policy" className="footer-link" aria-label="Terms and Conditions">
          Policy
        </Link> */}
        
       
      </div>

      <div className="footer-center">
        <span className="footer-copyright-full">
          © 2025 AastroG — Your Personal Astro Guru
        </span>
        <span className="footer-copyright-mobile">
          © 2025 AastroG
        </span>
      </div>

      <div className="footer-right footer-social" role="navigation" aria-label="Social links">
        <a href="mailto:aastrogai@gmail.com" className="social-icon" title="Email" aria-label="Email">
          <i className="fa-solid fa-envelope" aria-hidden="true"></i>
        </a>

        <a href="tel:+918866822366" className="social-icon" title="Call us" aria-label="Call">
          <i className="fa-solid fa-phone" aria-hidden="true"></i>
        </a>

        <a href="https://wa.me/918866822366" target="_blank" rel="noopener noreferrer" className="social-icon" title="WhatsApp" aria-label="WhatsApp">
          <i className="fa-brands fa-whatsapp" aria-hidden="true"></i>
        </a>

        <a href="https://www.facebook.com/AastroGa" target="_blank" rel="noopener noreferrer" className="social-icon" title="Facebook" aria-label="Facebook">
          <i className="fa-brands fa-facebook" aria-hidden="true"></i>
        </a>

        <a href="https://www.instagram.com/aastrog" target="_blank" rel="noopener noreferrer" className="social-icon" title="Instagram" aria-label="Instagram">
          <i className="fa-brands fa-instagram" aria-hidden="true"></i>
        </a>

        <a href="https://x.com/aastro_g72636" target="_blank" rel="noopener noreferrer" className="social-icon" title="X / Twitter" aria-label="X">
          <i className="fa-brands fa-x-twitter" aria-hidden="true"></i>
        </a>
      </div>
    </footer>
  );
};

export default Footer;